// extracted by mini-css-extract-plugin
export default {"root":"h2j1wxLlT0YyJupDUrK_","placeHolderShimmer":"JYN4wv5KB7Z1RHLDjRaO"};